import React, { useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import vertexShader from "./vertex.glsl";
import fragmentShader from "./fragment.glsl";

export const Scene = () => {
  const { viewport } = useThree();
  const materialRef = useRef();

  const uniforms = useRef({
    u_aspect: { value: viewport.width / viewport.height }, // Set initial aspect ratio
  });

  useFrame(() => {
    // ✅ Update aspect ratio dynamically
    uniforms.current.u_aspect.value = viewport.width / viewport.height;
  });

  return (
    <mesh>
      {/* ✅ Use viewport width/height for correct size */}
      <planeGeometry args={[viewport.width, viewport.height, 254, 254]} />
      <shaderMaterial
        ref={materialRef}
        vertexShader={vertexShader}
        fragmentShader={fragmentShader}
        uniforms={uniforms.current} // ✅ Pass updated uniforms
      />
    </mesh>
  );
};
